/* eslint-disable unicorn/prefer-module */
import React from "react";
import { Header } from "../../components/Header";
import { VentasMiListaClientesV2 } from "../../components/VentasMiListaClientesV2";
import styles from "./VentasEjecutivoV2.module.scss";

const VentasEjecutivoV2 = () => (
  <div className={styles.containerVentasEjecutivo}>
    <VentasMiListaClientesV2
      renderHeader={(filtersContent) => <Header expandChildren>{filtersContent}</Header>}
      filterStyles={styles}
    />
  </div>
);

export default VentasEjecutivoV2;
